import React from "react";
import { PlayCircle } from "lucide-react";

export const ProductGuideVideo = ({ guide, poster, productName }) => (
  <div className="mt-10" data-testid="product-guide-video">
    <h3 className="text-base font-semibold text-ei-navy flex items-center gap-2">
      <PlayCircle className="w-4 h-4 text-ei-golddark" /> {guide.label || "Installation guide"}
    </h3>
    <div className="mt-4 rounded-md overflow-hidden bg-black border border-ei-mist">
      <video
        className="w-full h-auto aspect-video bg-black"
        controls
        playsInline
        preload="none"
        poster={guide.poster || poster}
        aria-label={guide.title || `${productName} installation guide`}
        data-testid="product-guide-video-player"
      >
        <source src={guide.src} type="video/mp4" />
      </video>
    </div>
    {guide.note && <p className="mt-3 text-xs text-ei-graphite/55 leading-relaxed border-l-2 border-ei-gold/60 pl-3">{guide.note}</p>}
  </div>
);
